import { client as _heyApiClient } from "./client.gen";
const accountingReportTemplateList = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/accounts/reports/templates",
    ...options
  });
};
const accountingReportTemplateCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/accounts/reports/templates",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const accountingReportTemplateUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/accounts/reports/templates/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const accountingReportTemplateStructureGet = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/accounts/reports/templates/{id}/structure",
    ...options
  });
};
const accountingReportTemplateStructureFoldersUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/accounts/reports/templates/{id}/structure/folders",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const healthy = (options) => {
  return (options?.client ?? _heyApiClient).get({
    url: "/application/healthy",
    ...options
  });
};
const systemSettings = (options) => {
  return (options?.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/application/settings",
    ...options
  });
};
const systemSettingGet = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/application/settings/{settingName}",
    ...options
  });
};
const recordBookings = (options) => {
  return (options?.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/bookings/list",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers
    }
  });
};
const categoryDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/category",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const categoryCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/category",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const categoryUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/category",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const categories = (options) => {
  return (options?.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/category/list",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers
    }
  });
};
const category = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/category/{categoryId}",
    ...options
  });
};
const eventsTicketCreate = (options) => {
  return (options?.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/events/ticket",
    ...options
  });
};
const diplomatList = (options) => {
  return (options?.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/external/sha/diplomat/list",
    ...options
  });
};
const diplomatGet = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/external/sha/diplomat/{diplomatId}",
    ...options
  });
};
const fieldDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/field",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const field = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/field",
    ...options
  });
};
const fieldCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/field",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const fieldUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/field",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const fields = (options) => {
  return (options?.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/field/list",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers
    }
  });
};
const fieldLocatedIn = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/field/{fieldId}/located-in",
    ...options
  });
};
const fieldGroupDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/fieldgroup",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const fieldGroupSingle = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/fieldgroup",
    ...options
  });
};
const fieldGroupCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/fieldgroup",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const fieldGroupUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/fieldgroup",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const fieldGroupFilterForOrganization = (options) => {
  return (options?.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/fieldgroup/filter",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers
    }
  });
};
const fileCreateBlank = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/files/blank",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const fileCopyInitialize = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/files/copy",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const fileCopyCancel = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/files/copy/{tenantId}/{copyJobId}",
    ...options
  });
};
const fileCopyQuery = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/files/copy/{tenantId}/{copyJobId}",
    ...options
  });
};
const createFileFolder = (options) => {
  return (options?.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/files/folders",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers
    }
  });
};
const deleteFileFolder = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/files/folders/{folderId}",
    ...options
  });
};
const updateFileFolder = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/files/folders/{folderId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const treeFolder = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/files/folders/{folderId}/tree",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const fileMove = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/files/move",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const fileRelocateInitialize = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/files/relocate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const fileRelocateCancel = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/files/relocate/{tenantId}/{relocateJobId}",
    ...options
  });
};
const fileRelocateQuery = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/files/relocate/{tenantId}/{relocateJobId}",
    ...options
  });
};
const initializeFileUpload = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/files/transfer",
    ...options
  });
};
const downloadFileSignedUrl = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/files/transfer/signed_url/{objectName}",
    ...options
  });
};
const createDownloadFileSignedUrl = (options) => {
  return (options.client ?? _heyApiClient).head({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/files/transfer/signed_url/{objectName}",
    ...options
  });
};
const deleteFile = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/files/transfer/{objectName}",
    ...options
  });
};
const downloadFile = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/files/transfer/{objectName}",
    ...options
  });
};
const queryFile = (options) => {
  return (options.client ?? _heyApiClient).head({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/files/transfer/{objectName}",
    ...options
  });
};
const performFileUpload = (options) => {
  return (options.client ?? _heyApiClient).patch({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/files/transfer/{objectName}",
    ...options,
    headers: {
      "Content-Type": "application/offset+octet-stream",
      ...options.headers
    }
  });
};
const fileGet = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/files/{fileId}",
    ...options
  });
};
const fileEditorOoConfig = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/files/{fileId}/editor/oo/config",
    ...options
  });
};
const fileGetVersions = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/files/{fileId}/versions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const fileUpdateVersionNote = (options) => {
  return (options.client ?? _heyApiClient).patch({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/files/{fileId}/versions/{version}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const fileRestoreVersion = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/files/{fileId}/versions/{version}/restore",
    ...options
  });
};
const filterDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/filter",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const filterCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/filter",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const filterUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/filter",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const filters = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/filter/list",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const filterOrdersUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/filter/orders",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const filterTemplateVisibility = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/filter/template/visibility",
    ...options
  });
};
const filterTemplateVisibilityUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/filter/template/visibility",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const filter = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/filter/{filterId}",
    ...options
  });
};
const googleOauthCallback = (options) => {
  return (options.client ?? _heyApiClient).get({
    url: "/google/oauth/callback",
    ...options
  });
};
const googleOauthInit = (options) => {
  return (options.client ?? _heyApiClient).get({
    url: "/google/oauth/init",
    ...options
  });
};
const usergroupAdd = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/groups",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const usergroupUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/groups",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const usergroupRemove = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/groups/{groupId}",
    ...options
  });
};
const usergroupById = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/groups/{groupId}",
    ...options
  });
};
const usergroupMemberList = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/groups/{groupId}/members",
    ...options
  });
};
const usergroupMembersModify = (options) => {
  return (options.client ?? _heyApiClient).patch({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/groups/{groupId}/members",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const usergroupRoleList = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/groups/{groupId}/roles",
    ...options
  });
};
const usergroupRolesModify = (options) => {
  return (options.client ?? _heyApiClient).patch({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/groups/{groupId}/roles/{organisationId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const fileEditorOoCallback = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/internal/files/{fileId}/editor/oo/callback",
    ...options
  });
};
const microsoftGraphLifecycle = (options) => {
  return (options.client ?? _heyApiClient).post({
    url: "/microsoft/graph/lifecycle",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const microsoftGraphNotifications = (options) => {
  return (options.client ?? _heyApiClient).post({
    url: "/microsoft/graph/notifications",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const moduleDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/module",
    ...options
  });
};
const moduleCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/module",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const moduleUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/module",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const modules = (options) => {
  return (options?.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/module/list",
    ...options
  });
};
const moduleFields = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/module/listFields",
    ...options
  });
};
const modulePriorities = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/module/listPriorities",
    ...options
  });
};
const moduleStatuses = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/module/listStatuses",
    ...options
  });
};
const moduleRelationsGet = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/module/{moduleId}/relations",
    ...options
  });
};
const moduleRelationsUpdate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/module/{moduleId}/relations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const moduleSettingsGet = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/module/{moduleId}/settings",
    ...options
  });
};
const moduleSettingsUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/module/{moduleId}/settings",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const moduleSettingGet = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/module/{moduleId}/settings/{settingName}",
    ...options
  });
};
const moduleFolderDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/modules/folders/{folderId}",
    ...options
  });
};
const moduleChildFolderCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/modules/folders/{folderId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const moduleFolderUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/modules/folders/{folderId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const moduleFolderStructure = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/modules/folders/{folderId}/structure",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const moduleFolderTemplateDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/modules/folders/{folderId}/templates/{templateId}",
    ...options
  });
};
const moduleFolderTemplateAppend = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/modules/folders/{folderId}/templates/{templateId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const moduleFolderTemplateUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/modules/folders/{folderId}/templates/{templateId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const moduleRootFolderCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/modules/{moduleId}/folders",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const moduleFoldersStructure = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/modules/{moduleId}/folders/structure",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const organizationDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/organization",
    ...options
  });
};
const organization = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/organization",
    ...options
  });
};
const organizationCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/organization",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const organizationUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/organization",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const organizationList = (options) => {
  return (options?.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/organization/list",
    ...options
  });
};
const organizationTree = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/organization/tree",
    ...options
  });
};
const organizationTreeForTenant = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/organization/treeForTenant",
    ...options
  });
};
const organizationAccounts = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/organizations/{organizationId}/accounts/list",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const organizationAccount = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/organizations/{organizationId}/accounts/{accountId}",
    ...options
  });
};
const organizationBookings = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/organizations/{organizationId}/bookings/list",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const filtersetIndividualPermissionCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/permission/filterset",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const filtersetIndividualPermissionList = (options) => {
  return (options?.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/permission/filterset/list",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers
    }
  });
};
const filtersetIndividualPermissionDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/permission/filterset/{permissionId}",
    ...options
  });
};
const filtersetIndividualPermissionUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/permission/filterset/{permissionId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const forMe = (options) => {
  return (options?.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: "form"
      }
    },
    url: "/permission/forMe",
    ...options
  });
};
const recordIndividualPermissionCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/permission/record",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const recordIndividualPermissionList = (options) => {
  return (options?.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/permission/record/list",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers
    }
  });
};
const recordIndividualPermissionDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/permission/record/{permissionId}",
    ...options
  });
};
const recordIndividualPermissionUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/permission/record/{permissionId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const rolePermission = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/permission/role/{roleId}",
    ...options
  });
};
const modulePermissionRevoke = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/permission/role/{roleId}/module/{moduleId}",
    ...options
  });
};
const modulePermissionGrant = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/permission/role/{roleId}/module/{moduleId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const moduleTemplatesPermissionGrantAll = (options) => {
  return (options.client ?? _heyApiClient).patch({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/permission/role/{roleId}/module/{moduleId}/templates",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const modulePermissionGrantAll = (options) => {
  return (options.client ?? _heyApiClient).patch({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/permission/role/{roleId}/modules",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const settingPermissionRevoke = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/permission/role/{roleId}/setting/{settingName}",
    ...options
  });
};
const settingPermissionGrant = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/permission/role/{roleId}/setting/{settingName}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const settingPermissionGrantAll = (options) => {
  return (options.client ?? _heyApiClient).patch({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/permission/role/{roleId}/settings",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const templatePermissionRevoke = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/permission/role/{roleId}/template/{templateId}",
    ...options
  });
};
const templatePermissionGrant = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/permission/role/{roleId}/template/{templateId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const templatePermissionGrantAll = (options) => {
  return (options.client ?? _heyApiClient).patch({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/permission/role/{roleId}/templates",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const productPriceUpsert = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/product-prices",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const productPricesList = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/product-prices/list",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const productPriceMostRelevant = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/product-prices/relevant",
    ...options
  });
};
const productPriceDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/product-prices/{id}",
    ...options
  });
};
const proxyImage = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/proxy/image",
    ...options
  });
};
const recordsDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/record",
    ...options
  });
};
const record = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/record",
    ...options
  });
};
const recordCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/record",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const recordUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/record",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const recordsChangeTemplate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/record/change-template",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const createDraftSet = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/record/draft",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const discardDraftSet = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/record/draft/{draftSetId}",
    ...options
  });
};
const draftSet = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/record/draft/{draftSetId}",
    ...options
  });
};
const records = (options) => {
  return (options?.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/record/list",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers
    }
  });
};
const recordsAggregate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/record/list/aggregate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const recordsCount = (options) => {
  return (options?.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/record/list/count",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers
    }
  });
};
const recordsGroups = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/record/list/groups",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const recordsMinimal = (options) => {
  return (options?.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/record/list/minimal",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers
    }
  });
};
const countRecordsForTemplates = (options) => {
  return (options?.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/record/list/templates",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers
    }
  });
};
const recordsPurge = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/record/purge",
    ...options
  });
};
const recordsSetReadStatus = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/record/read-status",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const recordsRestore = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/record/restore",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const listRecordAccessRights = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/record/{recordId}/access-rights",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const initializeRecordAvatarUpload = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/record/{recordId}/avatar",
    ...options
  });
};
const recordEvents = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/record/{recordId}/events",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const recordFilesPermissionUpdate = (options) => {
  return (options.client ?? _heyApiClient).patch({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/record/{recordId}/files/permission",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const updateRecordUpdatedMetadata = (options) => {
  return (options.client ?? _heyApiClient).patch({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/record/{recordId}/meta",
    ...options
  });
};
const getRecordOrigin = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/record/{recordId}/origin",
    ...options
  });
};
const getTemplateFeaturesForRecord = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/record/{recordId}/template/features/{featureType}",
    ...options
  });
};
const listRecordUsers = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/record/{recordId}/users/list",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const recordPriorityCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/recordpriorities",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const recordPriorityDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/recordpriorities/{priorityId}",
    ...options
  });
};
const recordPriority = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/recordpriorities/{priorityId}",
    ...options
  });
};
const recordPriorityUpdate = (options) => {
  return (options.client ?? _heyApiClient).put(
    {
      security: [
        {
          scheme: "bearer",
          type: "http"
        }
      ],
      url: "/recordpriorities/{priorityId}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers
      }
    }
  );
};
const recordPrioritySetCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/recordprioritysets",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const recordPrioritySetDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/recordprioritysets/{prioritySetId}",
    ...options
  });
};
const recordPrioritySet = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/recordprioritysets/{prioritySetId}",
    ...options
  });
};
const recordPrioritySetUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/recordprioritysets/{prioritySetId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const recordPrioritySetLocatedIn = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/recordprioritysets/{prioritySetId}/located-in",
    ...options
  });
};
const recordPrioritySetPriorities = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/recordprioritysets/{prioritySetId}/priorities",
    ...options
  });
};
const recordPrioritySetPriorityCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/recordprioritysets/{prioritySetId}/priorities",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const recordActionBulkUpdate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/records/actions/bulk-update",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const recordActionClassify = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/records/actions/classify",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const recordActionCreateFrom = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/records/actions/create-from",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const recordAssignmentDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/records/assignments/{recordAssignmentId}",
    ...options
  });
};
const recordAssignmentUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/records/assignments/{recordAssignmentId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const recordExplicitRelationDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/records/relations/explicit",
    ...options
  });
};
const recordExplicitRelationUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/records/relations/explicit/{recordExplicitRelationId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const recordVersions = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/records/versions/list",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const recordActionApply = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/records/{recordId}/actions/{action}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const recordAssignmentCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/records/{recordId}/assignments",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const recordAssignments = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/records/{recordId}/assignments/list",
    ...options
  });
};
const removeRecordCategories = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/records/{recordId}/categories",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const addRecordCategories = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/records/{recordId}/categories",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const recordExplicitRelationCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/records/{recordId}/relations/explicit",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const recordExplicitRelationList = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/records/{recordId}/relations/explicit/list",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const recordFollowupList = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/records/{recordId}/relations/followup",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const recordStatusCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/recordstatuses",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const recordStatusDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/recordstatuses/{statusId}",
    ...options
  });
};
const recordStatus = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/recordstatuses/{statusId}",
    ...options
  });
};
const recordStatusUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/recordstatuses/{statusId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const recordStatusSetCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/recordstatussets",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const recordStatusSetDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/recordstatussets/{statusSetId}",
    ...options
  });
};
const recordStatusSet = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/recordstatussets/{statusSetId}",
    ...options
  });
};
const recordStatusSetUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/recordstatussets/{statusSetId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const recordStatusSetLocatedIn = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/recordstatussets/{statusSetId}/located-in",
    ...options
  });
};
const recordStatusSetStatuses = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/recordstatussets/{statusSetId}/statuses",
    ...options
  });
};
const recordStatusSetStatusCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/recordstatussets/{statusSetId}/statuses",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const roleCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/role",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const roleUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/role",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const roleListForOrganization = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/role/list/forOrganization",
    ...options
  });
};
const roleListForTenant = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/role/list/forTenant",
    ...options
  });
};
const roleRemove = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/role/{roleId}",
    ...options
  });
};
const roleGet = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/role/{roleId}",
    ...options
  });
};
const roleUserList = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/role/{roleId}/users",
    ...options
  });
};
const settingsGet = (options) => {
  return (options?.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/settings",
    ...options
  });
};
const settingGet = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/settings/{settingName}",
    ...options
  });
};
const aiPromptAdminGetGlobal = (options) => {
  return (options?.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/system-settings/ai-system-prompts",
    ...options
  });
};
const aiPromptAdminUpdateGlobal = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/system-settings/ai-system-prompts",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const aiPromptAdminReference = (options) => {
  return (options?.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/system-settings/ai-system-prompts/reference",
    ...options
  });
};
const tagDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tag",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const tagCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tag",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const tagUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tag",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const tags = (options) => {
  return (options?.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tag/list",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers
    }
  });
};
const templateDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/template",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const template = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/template",
    ...options
  });
};
const templateCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/template",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const templates = (options) => {
  return (options?.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/template/list",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers
    }
  });
};
const templatePatch = (options) => {
  return (options.client ?? _heyApiClient).patch({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/template/update",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const templateUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/template/update",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const templateCopy = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/template/{templateId}/copy",
    ...options
  });
};
const templateRecordPriorities = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/template/{templateId}/recordpriorities",
    ...options
  });
};
const templateRecordStatuses = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/template/{templateId}/recordstatuses",
    ...options
  });
};
const templateSectionFieldBlockDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/templates/sections/field-blocks/{blockId}",
    ...options
  });
};
const templateSectionFieldBlockGet = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/templates/sections/field-blocks/{blockId}",
    ...options
  });
};
const templateSectionFieldBlockUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/templates/sections/field-blocks/{blockId}",
    ...options
  });
};
const templateSectionDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/templates/sections/{sectionId}",
    ...options
  });
};
const templateSectionGet = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/templates/sections/{sectionId}",
    ...options
  });
};
const templateSectionUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/templates/sections/{sectionId}",
    ...options
  });
};
const templateSectionFieldBlockList = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/templates/sections/{sectionId}/field-blocks",
    ...options
  });
};
const templateSectionFieldBlockCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/templates/sections/{sectionId}/field-blocks",
    ...options
  });
};
const templateKindList = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/templates/{templateId}/kinds",
    ...options
  });
};
const templateKindCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/templates/{templateId}/kinds",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const templateKindDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/templates/{templateId}/kinds/{kindId}",
    ...options
  });
};
const templateKindGet = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/templates/{templateId}/kinds/{kindId}",
    ...options
  });
};
const templateKindUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/templates/{templateId}/kinds/{kindId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const templateKindCopy = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/templates/{templateId}/kinds/{kindId}/copy",
    ...options
  });
};
const templateKindSectionList = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/templates/{templateId}/kinds/{kindId}/sections",
    ...options
  });
};
const templateKindSectionUpsert = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/templates/{templateId}/kinds/{kindId}/sections",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const templateSectionList = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/templates/{templateId}/sections",
    ...options
  });
};
const templateSectionCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/templates/{templateId}/sections",
    ...options
  });
};
const simpleTenantUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenant",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const tenantsForMe = (options) => {
  return (options?.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenant/forMe",
    ...options
  });
};
const tenantGet = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenant/{tenantId}",
    ...options
  });
};
const usergroupsForTenant = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenant/{tenantId}/groups",
    ...options
  });
};
const tenantRecordPrioritySets = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenant/{tenantId}/recordprioritysets",
    ...options
  });
};
const tenantRecordPrioritySetCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenant/{tenantId}/recordprioritysets",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const tenantRecordStatusSets = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenant/{tenantId}/recordstatussets",
    ...options
  });
};
const tenantRecordStatusSetCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenant/{tenantId}/recordstatussets",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const usersForTenant = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenant/{tenantId}/users",
    ...options
  });
};
const tenant = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenantmanagement",
    ...options
  });
};
const tenantCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenantmanagement",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const tenantUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenantmanagement",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const tenantCleanupFiles = (options) => {
  return (options?.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenantmanagement/cleanupFiles",
    ...options
  });
};
const tenantCopy = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenantmanagement/copy",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const tenantCopyStructure = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenantmanagement/copyStructure",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const tenantDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenantmanagement/delete",
    ...options
  });
};
const tenantManagementInitialize = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenantmanagement/initialize",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const tenantsList = (options) => {
  return (options?.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenantmanagement/list",
    ...options
  });
};
const tenantUsage = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenantmanagement/usage",
    ...options
  });
};
const listTenants = (options) => {
  return (options?.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants",
    ...options
  });
};
const tenantConfigCheck = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants/configs/checks",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const tenantConfigDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants/configs/{configId}",
    ...options
  });
};
const tenantConfigGet = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants/configs/{configId}",
    ...options
  });
};
const tenantConfigUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants/configs/{configId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const layoutSectionGroupDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants/layouts/section-groups/{groupId}",
    ...options
  });
};
const layoutSectionGroupGet = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants/layouts/section-groups/{groupId}",
    ...options
  });
};
const layoutSectionGroupUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants/layouts/section-groups/{groupId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const layoutSectionGroupLocatedIn = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants/layouts/section-groups/{groupId}/located-in",
    ...options
  });
};
const customSequenceDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants/sequences/{sequenceId}",
    ...options
  });
};
const customSequenceGet = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants/sequences/{sequenceId}",
    ...options
  });
};
const customSequenceUpdate = (options) => {
  return (options.client ?? _heyApiClient).put(
    {
      security: [
        {
          scheme: "bearer",
          type: "http"
        }
      ],
      url: "/tenants/sequences/{sequenceId}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers
      }
    }
  );
};
const customSequenceLocatedIn = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants/sequences/{sequenceId}/located-in",
    ...options
  });
};
const accountingBook = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants/{tenantId}/accounting/book",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const accountingBookingDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants/{tenantId}/accounting/booking",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const accountingBookingUpdate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants/{tenantId}/accounting/booking/{accountingBookingId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const tenantAccounts = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants/{tenantId}/accounts/list",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const tenantAccountSeed = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants/{tenantId}/accounts/seed",
    ...options
  });
};
const tenantBookings = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants/{tenantId}/bookings/list",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const tenantConfigList = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants/{tenantId}/configs",
    ...options
  });
};
const tenantConfigCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants/{tenantId}/configs",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const tenantConfigAiProcessingDefaults = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants/{tenantId}/configs/ai-processing/defaults",
    ...options
  });
};
const layoutSectionGroupList = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants/{tenantId}/layouts/section-groups",
    ...options
  });
};
const layoutSectionGroupCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants/{tenantId}/layouts/section-groups",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const customSequenceList = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants/{tenantId}/sequences",
    ...options
  });
};
const customSequenceCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants/{tenantId}/sequences",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const aiPromptAdminResetTenant = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants/{tenantId}/settings/ai-system-prompts",
    ...options
  });
};
const aiPromptAdminGetTenant = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants/{tenantId}/settings/ai-system-prompts",
    ...options
  });
};
const aiPromptAdminUpdateTenant = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants/{tenantId}/settings/ai-system-prompts",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const vatRateCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants/{tenantId}/vat-rates",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const vatRates = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/tenants/{tenantId}/vat-rates/list",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const userDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/user",
    ...options
  });
};
const userMe = (options) => {
  return (options?.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/user",
    ...options
  });
};
const userCreate = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/user",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const currentUserUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/user",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const userGroupList = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/user/{userId}/groups",
    ...options
  });
};
const userRoleList = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/user/{userId}/roles",
    ...options
  });
};
const userRoleChange = (options) => {
  return (options.client ?? _heyApiClient).patch({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/user/{userId}/roles/{organisationId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const userSecrets = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/user/{userId}/secrets",
    ...options
  });
};
const userGet = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/users/{userId}",
    ...options
  });
};
const userUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/users/{userId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const initializeUserAvatarUpload = (options) => {
  return (options.client ?? _heyApiClient).post({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/users/{userId}/avatar",
    ...options
  });
};
const userSettingsGet = (options) => {
  return (options?.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/usersettings",
    ...options
  });
};
const userSettingsUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/usersettings",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const userSettingGet = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/usersettings/{settingName}",
    ...options
  });
};
const userSettingUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/usersettings/{settingName}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
const vatRatesDelete = (options) => {
  return (options.client ?? _heyApiClient).delete({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    querySerializer: {
      array: {
        explode: false,
        style: "form"
      }
    },
    url: "/vat-rates",
    ...options
  });
};
const vatRate = (options) => {
  return (options.client ?? _heyApiClient).get({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/vat-rates/{vatRateId}",
    ...options
  });
};
const vatRateUpdate = (options) => {
  return (options.client ?? _heyApiClient).put({
    security: [
      {
        scheme: "bearer",
        type: "http"
      }
    ],
    url: "/vat-rates/{vatRateId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers
    }
  });
};
export {
  accountingBook,
  accountingBookingDelete,
  accountingBookingUpdate,
  accountingReportTemplateCreate,
  accountingReportTemplateList,
  accountingReportTemplateStructureFoldersUpdate,
  accountingReportTemplateStructureGet,
  accountingReportTemplateUpdate,
  addRecordCategories,
  aiPromptAdminGetGlobal,
  aiPromptAdminGetTenant,
  aiPromptAdminReference,
  aiPromptAdminResetTenant,
  aiPromptAdminUpdateGlobal,
  aiPromptAdminUpdateTenant,
  categories,
  category,
  categoryCreate,
  categoryDelete,
  categoryUpdate,
  countRecordsForTemplates,
  createDownloadFileSignedUrl,
  createDraftSet,
  createFileFolder,
  currentUserUpdate,
  customSequenceCreate,
  customSequenceDelete,
  customSequenceGet,
  customSequenceList,
  customSequenceLocatedIn,
  customSequenceUpdate,
  deleteFile,
  deleteFileFolder,
  diplomatGet,
  diplomatList,
  discardDraftSet,
  downloadFile,
  downloadFileSignedUrl,
  draftSet,
  eventsTicketCreate,
  field,
  fieldCreate,
  fieldDelete,
  fieldGroupCreate,
  fieldGroupDelete,
  fieldGroupFilterForOrganization,
  fieldGroupSingle,
  fieldGroupUpdate,
  fieldLocatedIn,
  fieldUpdate,
  fields,
  fileCopyCancel,
  fileCopyInitialize,
  fileCopyQuery,
  fileCreateBlank,
  fileEditorOoCallback,
  fileEditorOoConfig,
  fileGet,
  fileGetVersions,
  fileMove,
  fileRelocateCancel,
  fileRelocateInitialize,
  fileRelocateQuery,
  fileRestoreVersion,
  fileUpdateVersionNote,
  filter,
  filterCreate,
  filterDelete,
  filterOrdersUpdate,
  filterTemplateVisibility,
  filterTemplateVisibilityUpdate,
  filterUpdate,
  filters,
  filtersetIndividualPermissionCreate,
  filtersetIndividualPermissionDelete,
  filtersetIndividualPermissionList,
  filtersetIndividualPermissionUpdate,
  forMe,
  getRecordOrigin,
  getTemplateFeaturesForRecord,
  googleOauthCallback,
  googleOauthInit,
  healthy,
  initializeFileUpload,
  initializeRecordAvatarUpload,
  initializeUserAvatarUpload,
  layoutSectionGroupCreate,
  layoutSectionGroupDelete,
  layoutSectionGroupGet,
  layoutSectionGroupList,
  layoutSectionGroupLocatedIn,
  layoutSectionGroupUpdate,
  listRecordAccessRights,
  listRecordUsers,
  listTenants,
  microsoftGraphLifecycle,
  microsoftGraphNotifications,
  moduleChildFolderCreate,
  moduleCreate,
  moduleDelete,
  moduleFields,
  moduleFolderDelete,
  moduleFolderStructure,
  moduleFolderTemplateAppend,
  moduleFolderTemplateDelete,
  moduleFolderTemplateUpdate,
  moduleFolderUpdate,
  moduleFoldersStructure,
  modulePermissionGrant,
  modulePermissionGrantAll,
  modulePermissionRevoke,
  modulePriorities,
  moduleRelationsGet,
  moduleRelationsUpdate,
  moduleRootFolderCreate,
  moduleSettingGet,
  moduleSettingsGet,
  moduleSettingsUpdate,
  moduleStatuses,
  moduleTemplatesPermissionGrantAll,
  moduleUpdate,
  modules,
  organization,
  organizationAccount,
  organizationAccounts,
  organizationBookings,
  organizationCreate,
  organizationDelete,
  organizationList,
  organizationTree,
  organizationTreeForTenant,
  organizationUpdate,
  performFileUpload,
  productPriceDelete,
  productPriceMostRelevant,
  productPriceUpsert,
  productPricesList,
  proxyImage,
  queryFile,
  record,
  recordActionApply,
  recordActionBulkUpdate,
  recordActionClassify,
  recordActionCreateFrom,
  recordAssignmentCreate,
  recordAssignmentDelete,
  recordAssignmentUpdate,
  recordAssignments,
  recordBookings,
  recordCreate,
  recordEvents,
  recordExplicitRelationCreate,
  recordExplicitRelationDelete,
  recordExplicitRelationList,
  recordExplicitRelationUpdate,
  recordFilesPermissionUpdate,
  recordFollowupList,
  recordIndividualPermissionCreate,
  recordIndividualPermissionDelete,
  recordIndividualPermissionList,
  recordIndividualPermissionUpdate,
  recordPriority,
  recordPriorityCreate,
  recordPriorityDelete,
  recordPrioritySet,
  recordPrioritySetCreate,
  recordPrioritySetDelete,
  recordPrioritySetLocatedIn,
  recordPrioritySetPriorities,
  recordPrioritySetPriorityCreate,
  recordPrioritySetUpdate,
  recordPriorityUpdate,
  recordStatus,
  recordStatusCreate,
  recordStatusDelete,
  recordStatusSet,
  recordStatusSetCreate,
  recordStatusSetDelete,
  recordStatusSetLocatedIn,
  recordStatusSetStatusCreate,
  recordStatusSetStatuses,
  recordStatusSetUpdate,
  recordStatusUpdate,
  recordUpdate,
  recordVersions,
  records,
  recordsAggregate,
  recordsChangeTemplate,
  recordsCount,
  recordsDelete,
  recordsGroups,
  recordsMinimal,
  recordsPurge,
  recordsRestore,
  recordsSetReadStatus,
  removeRecordCategories,
  roleCreate,
  roleGet,
  roleListForOrganization,
  roleListForTenant,
  rolePermission,
  roleRemove,
  roleUpdate,
  roleUserList,
  settingGet,
  settingPermissionGrant,
  settingPermissionGrantAll,
  settingPermissionRevoke,
  settingsGet,
  simpleTenantUpdate,
  systemSettingGet,
  systemSettings,
  tagCreate,
  tagDelete,
  tagUpdate,
  tags,
  template,
  templateCopy,
  templateCreate,
  templateDelete,
  templateKindCopy,
  templateKindCreate,
  templateKindDelete,
  templateKindGet,
  templateKindList,
  templateKindSectionList,
  templateKindSectionUpsert,
  templateKindUpdate,
  templatePatch,
  templatePermissionGrant,
  templatePermissionGrantAll,
  templatePermissionRevoke,
  templateRecordPriorities,
  templateRecordStatuses,
  templateSectionCreate,
  templateSectionDelete,
  templateSectionFieldBlockCreate,
  templateSectionFieldBlockDelete,
  templateSectionFieldBlockGet,
  templateSectionFieldBlockList,
  templateSectionFieldBlockUpdate,
  templateSectionGet,
  templateSectionList,
  templateSectionUpdate,
  templateUpdate,
  templates,
  tenant,
  tenantAccountSeed,
  tenantAccounts,
  tenantBookings,
  tenantCleanupFiles,
  tenantConfigAiProcessingDefaults,
  tenantConfigCheck,
  tenantConfigCreate,
  tenantConfigDelete,
  tenantConfigGet,
  tenantConfigList,
  tenantConfigUpdate,
  tenantCopy,
  tenantCopyStructure,
  tenantCreate,
  tenantDelete,
  tenantGet,
  tenantManagementInitialize,
  tenantRecordPrioritySetCreate,
  tenantRecordPrioritySets,
  tenantRecordStatusSetCreate,
  tenantRecordStatusSets,
  tenantUpdate,
  tenantUsage,
  tenantsForMe,
  tenantsList,
  treeFolder,
  updateFileFolder,
  updateRecordUpdatedMetadata,
  userCreate,
  userDelete,
  userGet,
  userGroupList,
  userMe,
  userRoleChange,
  userRoleList,
  userSecrets,
  userSettingGet,
  userSettingUpdate,
  userSettingsGet,
  userSettingsUpdate,
  userUpdate,
  usergroupAdd,
  usergroupById,
  usergroupMemberList,
  usergroupMembersModify,
  usergroupRemove,
  usergroupRoleList,
  usergroupRolesModify,
  usergroupUpdate,
  usergroupsForTenant,
  usersForTenant,
  vatRate,
  vatRateCreate,
  vatRateUpdate,
  vatRates,
  vatRatesDelete
};
//# sourceMappingURL=sdk.gen.js.map